var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStudent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "76.000000pt",
    height: "42.000000pt",
    viewBox: "0 0 76.000000 42.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,42.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 365 c-214 -68 -207 -65 -175 -78 l26 -10 -23 -66 c-13 -36 -24 -81 -24 -98 0 -32 2 -33 39 -33 l38 0 7 61 c3 34 6 77 6 95 0 19 5 34 10 34 6 0 10 -4 10 -10 0 -5 8 -10 18 -10 9 0 70 -18 134 -40 l117 -39 103 35 c57 19 114 36 127 39 51 9 152 48 144 55 -7 6 -377 121 -385 119 -2 0 -79 -25 -172 -54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 151 c0 -74 21 -103 93 -127 69 -24 233 -24 297 0 71 27 80 39 80 118 0 37 -2 68 -5 68 -3 0 -56 -14 -117 -31 l-112 -31 -107 31 c-59 17 -113 31 -118 31 -7 0 -11 -24 -11 -59z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStudent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Student.82dad26ca9e2fbf3b66434fc2554e7f4.svg";